import {useState} from 'react'
import FormLangBar from '../../FormLangBar'
import { useCurrent } from '../../../hooks';
import { MwTextArea } from '../../ui';
import { useTranslation } from 'react-i18next';
import { PRODUCT_FORM_SECTION_CLASS } from '../productUi';

const SEO = ({
    productMetaKeywords,
    setProductMetaKeywords,
    productMetaDesc,
    setProductMetaDesc
}) => {

    const {currentLangList,currentLangId} = useCurrent();
    const [formLang,setFormLang] = useState(currentLangId);
    const [t] = useTranslation('global')
    return (
        <div className='space-y-4'>
            <FormLangBar currentLangList = {currentLangList} formLang = {formLang} setFormLang = {setFormLang} />
            { currentLangList.map((lang) => (
            <div key={lang.langCode} className={PRODUCT_FORM_SECTION_CLASS}>
                <div className={` ${ formLang === lang?.langCode ? 'block' : 'hidden' } `}>
                    <div id='productMetaKeywords' className='my-2'>
                        <MwTextArea
                            id={`productMetaKeywords${lang?.langCode}`}
                            label={`${t('product.seo_keywords_with_lang')} (${lang.langName})`}
                            value={productMetaKeywords[lang?.langCode]}
                            placeholder={`${t('product.seo_keywords_with_lang')} (${lang.langName})`}
                            rows={4}
                            onChange={(e ) => setProductMetaKeywords({...productMetaKeywords,[lang?.langCode]:e.target.value})}
                        />
                    </div>
                    <div id='productMetaDesc' className='my-2'>
                        <MwTextArea
                            id={`productMetaDesc${lang?.langCode}`}
                            label={`${t('product.seo_description_with_lang')} (${lang.langName})`}
                            value={productMetaDesc[lang?.langCode]}
                            placeholder={`${t('product.seo_description_with_lang')} (${lang.langName})`}
                            rows={4}
                            onChange={(e ) => setProductMetaDesc({...productMetaDesc,[lang?.langCode]:e.target.value})}
                        />
                    </div>
                </div>
            </div>
            )) }
        </div>
    )
}

export default SEO
